export default {
  dataRoomUi: {
    loading: false,
  },
  dataRoomFilters: {
    monthReferenceBr: '',
  },
  activeHistory: {
    loading: false,
    lastUpdate: null,
    data: [],
    removed: [],
    edited: [],
  },
  accounts: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  activeCurrent: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  operations: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  operationsBase: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  currentStatusStep: null,
  comparisonInvestmentAccounts: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  suggestions: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  // {{NEXT}}
}
